<template>
  <Loading :loadingConfig="loadingConfig" v-if="showLoading" />
  <div v-if="isMobile" class="mobile-message">{{ t('home.phoneTips') }}</div>
  <div class="page">
    <div class="page-left">
      <el-tooltip
        effect="dark"
        :content="t('home.tooltip1')"
        placement="right"
      >
        <div role="button"
          class="btn"
          style="background: rgba(56, 112, 255, 1); opacity: 0.7"
          :class="checkTitle == '0' ? 'opacity: 1;' : ''"
          @click="functionOption(0)"
        >
          {{ t('home.btnName1') }}
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        :content="t('home.tooltip2')"
        placement="right"
      >
        <div role="button"
          class="btn"
          style="background: rgba(0, 186, 173, 1); opacity: 0.7"
          @click="functionOption(1)"
        >
        {{ t('home.btnName2') }}
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        :content="t('home.tooltip3')"
        placement="right"
      >
        <div role="button"
          class="btn"
          style="background: rgba(135, 191, 255, 1); opacity: 0.7"
          :style="checkTitle == '2' ? 'opacity: 1;' : ''"
          @click="functionOption(2)"
        >
        {{ t('home.btnName3') }}
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        :content="t('home.tooltip4')"
        placement="right"
      >
        <div role="button"
          class="btn"
          style="background: rgba(255, 168, 82, 1); opacity: 0.7"
          :style="checkTitle == '3' ? 'opacity: 1;' : ''"
          @click="functionOption(3)"
        >
        {{ t('home.btnName4') }}
        </div>
      </el-tooltip>
      <img :src="bg" alt="" />
    </div>
    <div class="page-main">
      <div class="search" :style="checkTitle != '2'?'padding-right: 0;':''" v-if="isLoginForDisplay">
        <el-input
          v-model="topic"
          style="width: 100%"
          autosize
          type="textarea"
          :placeholder="getPlaceholder()"
        />
        <!--        <input type="textarea" placeholder="请输入题目..." v-model="topic" style="background:white;" v-else />-->
        <div class="btn-box" v-if="checkTitle == '2'" @click="execute">
          <div class="btn"><img :src="search" alt="" /></div>
        </div>
      </div>
      <!-- <div class="hot-list">
        <div class="hot-item" v-for="item in 4" :key="item">
          <img :src="hot" alt="">
          <span>热门搜索词{{ item }}</span>
        </div>
      </div> -->
      <!-- <div class="type-list" v-if="checkTitle == '0'">
        <div class="type-item" :class="checkType == '0'?'active':''" @click="checkType='0'">机考</div>
        <div class="type-item" :class="checkType == '1'?'active':''" @click="checkType='1'">笔考</div>
      </div> -->
      <div class="content" v-if="checkTitle == '0' || checkTitle == '3'">
        <div class="info" v-if="isLoginForDisplay">
          <div class="u-flex">
            <div class="title">{{ titleInfo[checkTitle] }}</div>
            <!--            <el-select v-model="checkType" style="width: 5.83vw;" v-if="checkTitle == '0'">-->
            <!--              <el-option-->
            <!--                label="机考"-->
            <!--                value="0"-->
            <!--              />-->
            <!--              <el-option-->
            <!--                label="笔考"-->
            <!--                value="1"-->
            <!--              />-->
            <!--            </el-select>-->
          </div>
          <div class="tips">
            <div class="tip-item">{{ wordCount() }} words</div>
            <div class="tip-item">{{ countSentences() }} sentences</div>
          </div>
        </div>
        <div class="word">
          <textarea
            class="textarea"
            contenteditable="true"
            :placeholder="t('home.textareaPlaceholder1')"
            v-model="content"
            v-if="isLoginForDisplay && !isFirst"
          />
          <span v-else-if="isLoginForDisplay && isFirst">
            <span style="font-weight: 500; padding-left: 2vw">{{ t('home.span1') }}<br/></span>
          </span>
          <span  v-else v-html="t('home.welcome1')"></span>
        </div>
      </div>
      <div class="execute-box" v-if="checkTitle == '0'">
        <div role="button" class="execute" v-if="isLoginForDisplay" @click="execute">{{ t('home.btnName5') }}</div>
      </div>
      <div class="execute-box" v-if="checkTitle == '3'">
        <div role="button" class="execute" v-if="isLoginForDisplay" @click="execute">{{ t('home.btnName6') }}</div>
      </div>
    </div>
    <div class="page-right">
      <div class="title">
        {{ rightTitle }} <span v-if="isLoginForDisplay" @click="router.push('list')">{{ t('home.more')
        }}></span>
      </div>
      <div class="list" ref="searchContentBox">
        <el-scrollbar>
            <a style="text-decoration: none;"
               class="list-item"
               :style="getStyleByLevel(item.overallScore).border"
               v-for="item in list1"
               :key="item.id"
               :href="item.nextPage ? item.nextPage : `sample?id=${item.id}`">
              <div
                class="item-score"
                :style="getStyleByLevel(item.overallScore).score"
              >
                {{ item.overallScore }}
              </div>
              <div class="item-content">
                <div class="item-info u-line-3">{{ item.topic }}</div>
                <div class="item-time">{{ item.createTime }}</div>
              </div>
            </a>
            <a style="text-decoration: none;"
               class="list-item"
               :style="getStyleByLevel(item.overallScore).score"
               v-for="item in list2"
               :key="item.id"
               :href="item.nextPage ? item.nextPage : `perspectiveExtend?id=${item.id}`">
            <el-tooltip
              effect="dark"
              :content="t('home.tooltip5')"
              placement="left"
            >
              <div class="item-score">{{t('home.div1')}}</div>
            </el-tooltip>
            <div class="item-content">
              <div class="item-info u-line-3">{{ item.topic }}</div>
              <div class="item-time">{{ item.createTime }}</div>
            </div>
            </a>
          <a style="text-decoration: none;"
             class="list-item"
             :style="getStyleByLevel(item.overallScore).border"
             v-for="item in list3"
             :key="item.id"
             :href="item.nextPage ? item.nextPage : `continueWriting?id=${item.id}`">
            <el-tooltip
              effect="dark"
              :content="t('home.tooltip6')"
              placement="left"
            >
              <div class="item-score">{{t('home.div2')}}</div>
            </el-tooltip>
            <div class="item-content">
              <div class="item-info u-line-3">{{ item.topic }}</div>
              <div class="item-time">{{ item.createTime }}</div>
            </div>
          </a>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script setup>
//import { navigateTo } from '../router/index'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useAppStore } from '@/store/index'
import bg from '../assets/home/bg.png'
import search from '../assets/home/search.png'
import hot from '../assets/home/hot.png'
import listtitle from '../assets/home/listtitle.png'
import Loading from '../components/Loading.vue'

import {
  essayListByAccount,
  perspectiveExtendListByAccount,
  continueWritingListByAccount,
  randomOneTopic,
  checkDivide,
  newExtend,
  newContinueWriting,
} from '@/api/api'
import { useHead,useSeoMeta } from '@vueuse/head';
import i18n from '../locale/i18n';
import { useRouter } from 'vue-router';

const router = useRouter();
const t = (key) => i18n.global.t(key);

const store = useAppStore()
const showLoading = ref(false)
const checkType = ref('0') // 类型：0为机考，1为笔考
const titleInfo = { 0: t("home.btnName1"), 1: '随机主题', 2: '思路扩展', 3: t("home.div2") }
const checkTitle = ref('0') //
const topic = ref('') // 文章标题
const content = ref('') // 文章内容
const rightTitle = ref('') //右侧标题
const isLoginForDisplay = ref(false) //未登录与登录后的区别
const isFirst = ref(false)
const list1 = ref([])
const list2 = ref([])
const list3 = ref([])
const searchContentBox = ref('')
const isMobile = ref(false);
const loadingConfig = ref({
  action: (flag) => {
    showLoading.value = flag
  },
})
const token = ref(store.token);
const jsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "url": "https://ielts.xzlink.com", // 当前网站 URL
  "name": t("meta.title"), // 网站名称
  "description": t("meta.description"), // 描述
  "publisher": {
    "@type": "Organization",
    "name": t("meta.name"),
    "logo": {
      "@type": "ImageObject",
      "url": "https://ielts.xzlink.com/favicon.ico" // Logo URL
    }
  }
};
const jsonLd1 = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": t("meta.name"),
  "operatingSystem": "Web",
  "applicationCategory": "EducationalApplication",
  "url": "https://ielts.xzlink.com",
  "description": "",
  "offers": {
    "@type": "Offer",
    "price": "0.00",
    "priceCurrency": "USD",
    "availability": "https://schema.org/InStock"
  }
};

let domain="";
if(import.meta.env.VITE_LANG=='en'){
  domain = "https://ielts.xzlink.com";
}else{
  domain = "https://www.xzlink.com";
}
useHead({
  htmlAttrs: {
    lang: t("common.lang") // 动态设置 lang 属性
  },
  title: t("meta.title"),
  meta: [
    { name: 'description', content: t("meta.description") },
    { name: 'keywords', content: t("meta.keywords") },
  ],
  //link:[
  //  {ref:'canonical', href: domain},
  //],
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify(jsonLd) // 转为字符串插入到 <script> 标签中
    },
    {
      type: "application/ld+json",
      children: JSON.stringify(jsonLd1) // 转为字符串插入到 <script> 标签中
    }
  ]
});
useSeoMeta({
  ogTitle: t("meta.title"),
  ogDescription: t("meta.description"),
  ogImage: domain+'/favicon.ico',
  ogUrl: domain,
  ogType:'website',
})
const checkDevice = () => {
  isMobile.value = window.innerWidth <= 600;
};
const placeholderInfo = {
  nLogin: {
    0: t("home.message1"),
    2: t("home.message1"),
    3: t("home.message1"),
  },
  yLogin: {
    0: t("home.message2"),
    2: t("home.message3"),
    3: t("home.message4"),
  },
}

const functionOption = (type) => {
  if(token.value) {
    if (isLoginForDisplay.value) {
      if (type == 1) {
        getRandomOneTopic()
        //return;
      }
      checkTitle.value = type
      isFirst.value = false
      console.log(type)
    }
  } else {
    store.isLogin(true)
  }
}
const getPlaceholder = () => {
  let placeholder = ''
  if (!isFirst) {
    placeholder = placeholderInfo.yLogin[checkTitle.value]
  } else {
    placeholder = placeholderInfo.yLogin[checkTitle.value]
  }
  return placeholder
}

// 按钮
const execute = async () => {
  if (!store.token) {
    store.isLogin(true)
    return
  }
  if (topic.value == '') {
    ElMessage({
      message: t("home.message5"),
      type: 'warning',
    })
    return
  }
  if (
    (checkTitle.value == '0' || checkTitle.value == '3') &&
    content.value == ''
  ) {
    ElMessage({
      message: t("home.message6"),
      type: 'warning',
    })
    return
  }
  const topicTitle = topic.value
  const contentTitle = content.value
  let res = null
  if (checkTitle.value == '0') {
    res = await checkDivide({
      topic: topicTitle,
      content: contentTitle,
      type: checkType.value,
    })
  } else if (checkTitle.value == '1') {
  } else if (checkTitle.value == '2') {
    res = await newExtend({ topic: topicTitle })
  } else if (checkTitle.value == '3') {
    res = await newContinueWriting({
      topic: topicTitle,
      unFinishArticle: contentTitle,
    })
  }
  if (res.code == '200') {
    loadingConfig.value.info = {
      type: checkTitle,
      id: res.data,
    }
    showLoading.value = true
  }
}

const getStyleByLevel = (level) => {
  const levelBg0 =
    'background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(212, 224, 255, 1) 100%);color: rgba(56, 112, 255, 1);'
  const levelBorder0 = 'border: 0.05vw solid rgba(56, 112, 255, 1);'
  const levelBg1 =
    'background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 223, 191, 1) 100%);color: rgba(255, 128, 0, 1);'
  const levelBorder1 = 'border: 0.05vw solid rgba(255, 141, 26, 1);'
  const levelBg2 =
    'background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(208, 245, 223, 1) 100%);color: rgba(67, 207, 124, 1);'
  const levelBorder2 = 'border: 0.05vw solid rgba(67, 207, 124, 1);'
  const levelBg3 =
    'background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(240, 240, 240, 1) 100%);color: rgba(108, 111, 135, 1);'
  const levelBorder3 = 'border: 0.05vw solid rgba(207, 207, 207, 1);'

  if (level >= 6) {
    return {
      border: levelBorder0,
      score: levelBg0 + levelBorder0,
    }
  } else if (level >= 5) {
    return {
      border: levelBorder1,
      score: levelBg1 + levelBorder1,
    }
  } else if (level >= 4) {
    return {
      border: levelBorder2,
      score: levelBg2 + levelBorder2,
    }
  } else {
    return {
      border: levelBorder3,
      score: levelBg3 + levelBorder3,
    }
  }
}

// 获取随机主题
const getRandomOneTopic = async () => {
  if (topic.value == '') {
    const res = await randomOneTopic({})
    topic.value = res.data.topic
    checkTitle.value = 1
  } else {
    ElMessageBox.alert(t("home.message7"), t("home.message8"), {
      showCancelButton: true,
      callback: async (e) => {
        if (e == 'confirm') {
          const res = await randomOneTopic({})
          topic.value = res.data.topic
          checkTitle.value = 1
        }
      },
    })
  }
}

const wordCount = () => {
  if (content.value == '') {
    return 0
  }
  // 使用正则表达式分割空格来计算单词数量
  return content.value.trim().split(/\s+/).length
}
const countSentences = () => {
  // 使用正则表达式匹配句子
  return content.value.match(/\.( |　)/g)
    ? content.value.match(/\.( |　)/g).length + 1
    : 0
}

const getPage = async () => {
  const essayres = await essayListByAccount({ size: 4, current: 1 })
  list1.value = essayres.data.records
  const perspectiveExtendres = await perspectiveExtendListByAccount({
    size: 1,
    current: 1,
  })
  list2.value = perspectiveExtendres.data.records
  const continueWritingres = await continueWritingListByAccount({
    size: 1,
    current: 1,
  })
  list3.value = continueWritingres.data.records
}

var defaultSampleData = [
  {
    id: -1,
    accountId: 10,
    topic:
      'Some people think that media violence should be banned to reduce crimes. To what extent do you agree or disagree with this opinion?',
    content: null,
    createTime: '2024-11-30 15:40:20',
    type: 1,
    status: 2,
    overallScore: 5.5,
    nextPage: 'sample55',
  },
  {
    id: -2,
    accountId: 10,
    topic:
      'Some people believe that visitors to other countries should follow local customs and behaviour.Others disagree and think that the host country should welcome cultural differences.Discuss bother these views and give your opinion.',
    content: null,
    createTime: '2024-11-28 15:40:20',
    type: 1,
    status: 2,
    overallScore: 6,
    nextPage: 'sample6',
  },
]
var defaultPerspectiveExtendData = [
  {
    id: -4,
    accountId: -1,
    topic:
      'Some people think that instead of preventing climate change, we need to find a way to live with it. Do you agree or disagree?',
    status: 2,
    createTime: '2024-11-30 15:52:04',
    nextPage: 'perspectiveExtendSample',
  },
]
var defaultContinueWritingData = [
  {
    id: -4,
    accountId: -1,
    topic:
      'Universities should accept equal numbers of male and female students in every subject. To what extent do you agree or disagree？',
    status: 2,
    createTime: '2024-11-30 15:52:04',
    nextPage: 'continueWritingSample',
  },
]

const init = () => {
  if (!store.token) {
    list1.value = defaultSampleData
    list2.value = defaultPerspectiveExtendData
    list3.value = defaultContinueWritingData
    rightTitle.value = t("home.message9");
    return
  }
  list1.value = []
  list2.value = []
  list3.value = []
  rightTitle.value = 'Historical records'
  isLoginForDisplay.value = true
  getPage()
}
if (import.meta.env.SSR) {
  list1.value = defaultSampleData
  list2.value = defaultPerspectiveExtendData
  list3.value = defaultContinueWritingData
  rightTitle.value = t("home.message9");

}else{
  onMounted(() => {
    init();
    checkDevice();
  })
}

watch(
  () => [store.token],
  ([newValue1]) => {
    init()
  }
)


</script>

<style lang="less" scoped>
.page {
  width: 78.125vw;
  height: 100%;
  margin: 0 auto;
  padding-top: 2.8125vw;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  .page-left {
    width: 18.59vw;
    height: 100%;
    .btn {
      cursor: pointer;
      width: 18.59vw;
      height: 4.06vw;
      border-radius: 0.52vw;
      font-size: 1.56vw;
      font-weight: 900;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.5vw;
    }
    img {
      margin-top: 2.9vw;
      display: block;
      width: 18.59vw;
      height: auto;
    }
  }
  .page-main {
    width: 35.16vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    .search {
      width: 35.16vw;
      min-height: 2.97vw;
      border-radius: 0.52vw;
      background: rgba(255, 255, 255, 1);
      border: 0.1vw solid rgba(56, 112, 255, 1);
      position: relative;
      padding-left: 1.25vw;
      padding-right: 3.96vw;
      overflow: hidden;
      margin-bottom: 0.625vw;
      input {
        width: 100%;
        height: 2.95vw;
        font-size: 0.83vw;
        font-weight: 500;
        color: rgba(55, 59, 81, 1);
      }
      .btn-box {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        height: 2.97vw;
        width: 3.96vw;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn {
          width: 2.19vw;
          height: 2.19vw;
          background: linear-gradient(
            210.25deg,
            rgba(135, 191, 255, 1) 0%,
            rgba(186, 218, 255, 1) 100%
          );
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          img {
            width: 0.68vw;
            height: auto;
          }
        }
      }
    }
    .hot-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 1.146vw;
      .hot-item {
        margin-right: 1.09375vw;
        height: 1.46vw;
        line-height: 1.46vw;
        border-radius: 5.21vw;
        background: rgba(255, 255, 255, 1);
        padding: 0 0.625vw;
        font-size: 0.73vw;
        color: rgba(56, 112, 255, 1);
        margin-bottom: 0.325vw;
        img {
          width: 0.57vw;
          height: auto;
          margin-right: 0.325vw;
          vertical-align: middle;
        }
        span {
          vertical-align: middle;
        }
      }
    }
    .type-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 1.146vw;
      .type-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 5.83vw;
        height: 1.98vw;
        border-radius: 0.52vw;
        background: rgba(255, 255, 255, 1);
        font-size: 0.83vw;
        font-weight: 900;
        color: rgba(56, 112, 255, 1);
        border: 0.05vw solid rgba(255, 255, 255, 1);
        margin-right: 1.3vw;
      }
      .active {
        background: rgba(209, 222, 255, 1);
        border: 0.05vw solid rgba(56, 112, 255, 1);
      }
    }
    .content {
      flex: 1;
      margin-bottom: 1.615vw;
      width: 35.16vw;
      border-radius: 0.52vw;
      background: rgba(255, 255, 255, 1);
      box-shadow: -0.42vw -0.05vw 0.42vw rgba(209, 222, 255, 1);
      padding: 1.12vw 1.28vw 1.12vw 1.51vw;
      overflow: hidden;
      .info {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-bottom: 0.89vw;
        .title {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 5.83vw;
          height: 1.98vw;
          border-radius: 0.52vw;
          background: rgba(56, 112, 255, 1);
          font-size: 0.83vw;
          font-weight: 900;
          color: rgba(255, 255, 255, 1);
          margin-right: 1vw;
        }
        .tips {
          display: flex;
          .tip-item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 4.75vw;
            height: 1.56vw;
            border-radius: 5.21vw;
            background: rgba(223, 238, 254, 1);
            font-size: 0.63vw;
            font-weight: 900;
            color: rgba(56, 112, 255, 1);
            margin-left: 1.5vw;
          }
        }
      }
      .word {
        // height: 30.36vw;
        height: 100%;
        overflow-y: auto;
        font-size: 0.83vw;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        scrollbar-width: none; // 兼容火狐
        -ms-overflow-style: none; // 兼容IE10+
        /*  解决 ios 上滑动不流畅 */
        -webkit-overflow-scrolling: touch;
        .textarea {
          font-size: 0.83vw;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          width: 100%;
          height: 98%;
          scrollbar-width: none; // 兼容火狐
          -ms-overflow-style: none; // 兼容IE10+
          /*  解决 ios 上滑动不流畅 */
          -webkit-overflow-scrolling: touch;
        }
        :deep(.textarea::placeholder) {
          color: #f56c6c;
        }
        /* 谷歌 */
        :deep(.textarea::-webkit-input-placeholder) {
          color: #f56c6c;
        }
        /* 火狐 */
        :deep(.textarea:-moz-placeholder) {
          color: #f56c6c;
        }
        /*ie*/
        :deep(.textarea:-ms-input-placeholder) {
          color: #f56c6c;
        }
      }
    }
    .execute-box {
      display: flex;
      justify-content: flex-end;
      .execute {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12.45vw;
        height: 4.06vw;
        border-radius: 0.52vw;
        background: rgba(56, 112, 255, 1);
        font-size: 1.56vw;
        font-weight: 900;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .page-right {
    width: 18.59vw;
    height: 100%;
    .title {
      font-size: 1.25vw;
      font-weight: 900;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 0.55vw;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      span {
        cursor: pointer;
        font-size: 0.83vw;
        color: rgba(51, 51, 51, 1);
        font-weight: 200;
      }
    }
    .list {
      overflow-y: auto;
      height: calc(100vh - 2vw - 2.8125vw - 5.36vw);
      .list-item {
        cursor: pointer;
        display: flex;
        width: 18.59vw;
        height: 5.73vw;
        border-radius: 0.52vw;
        background: rgba(255, 255, 255, 1);
        margin-bottom: 10px;
        .item-score {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          width: 4.22vw;
          border-radius: 0.52vw 0vw 0vw 0.52vw;
          border-left: none !important;
          border-top: none !important;
          border-bottom: none !important;
          font-size: 1.25vw;
          font-weight: 800;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 1) 0%,
            rgba(240, 240, 240, 1) 100%
          );
          border: 0.05vw solid rgba(207, 207, 207, 1);
          img {
            width: 2.34vw;
            height: auto;
          }
        }
        .item-content {
          padding: 0.73vw 0.4vw 0.73vw 0.73vw;
          .item-info {
            font-size: 0.73vw;
            font-weight: 500;
            color: rgba(0, 0, 0, 1);
            margin-bottom: 0.4vw;
          }
          .item-time {
            font-size: 0.63vw;
            font-weight: 500;
            color: rgba(153, 153, 153, 1);
          }
        }
      }
    }
  }
}
.mobile-message {
  background-color: #FFD700;
  color: black;
  padding: 10px;
  text-align: center;
}
</style>
